import React, { useEffect, useRef } from "react";
import SliderButton from "./SliderButton";
import { useStateContext } from "../contexts/ContextProvider";
import { apiUpdateNotifications } from "../services/apiService";

const ManageNotifications = () => {
  const { user, notifications, setNotifications } = useStateContext();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      updateNotifications();
    } else {
      isMounted.current = true;
    }
  }, [notifications]);

  const handleNotifications = (name) => {
    setNotifications((prevState) => ({
      ...prevState,
      [name]: !notifications[name],
    }));
  };

  const updateNotifications = async () => {
    const response = await apiUpdateNotifications(notifications);
    if (response.hasError) {
      console.log(response.error.message);
    } else {
      console.log("notifications updated");
    }
  };

  return (
    <div className="w-full max-w-[500px]">
      <div className="grid grid-cols-2 text-lg gap-y-3 px-10 mt-10">
        <div className="text-xl">Notifications:</div>
        <div className="place-self-end text-xl pl-3">Off / On</div>
      </div>
      <div className="grid grid-cols-2 gap-y-3 px-10 mt-5">
        <div>New Messages</div>
        <div className="place-self-end">
          <SliderButton
            type="notification"
            value={notifications.newMessages}
            customFunc={() => {
              handleNotifications("newMessages");
            }}
          />
        </div>
        {user.defaultView === "landlord" ? (
          <>
            <div>Payments Received</div>
            <div className="place-self-end">
              <SliderButton
                type="notification"
                value={notifications.landlordRentReceived}
                customFunc={() => {
                  handleNotifications("landlordRentReceived");
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div>Rent Is Due</div>
            <div className="place-self-end">
              <SliderButton
                type="notification"
                value={notifications.tenantRentDue}
                customFunc={() => {
                  handleNotifications("tenantRentDue");
                }}
              />
            </div>
            <div>Rent Is Late</div>
            <div className="place-self-end">
              <SliderButton
                type="notification"
                value={notifications.tenantRentLate}
                customFunc={() => {
                  handleNotifications("tenantRentLate");
                }}
              />
            </div>
          </>
        )}
        {user.defaultView === "landlord" ? (
          <>
            <div>Room Inquiries</div>
            <div className="place-self-end">
              <SliderButton
                type="notification"
                value={notifications.landlordNewInquiries}
                customFunc={() => {
                  handleNotifications("landlordNewInquiries");
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div>Chore Reminders</div>
            <div className="place-self-end">
              <SliderButton
                type="notification"
                value={notifications.tenantChoreDue}
                customFunc={() => {
                  handleNotifications("tenantChoreDue");
                }}
              />
            </div>
          </>
        )}
        <div>Marketing offers</div>
        <div className="place-self-end">
          <SliderButton
            type="notification"
            value={notifications.marketing}
            customFunc={() => {
              handleNotifications("marketing");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ManageNotifications;
